/* eslint-disable no-extra-boolean-cast */
import axios from 'axios'
import NProgress from 'nprogress'
import router from '@/router'

const apiClientBlob = axios.create({
  baseURL: process.env.VUE_APP_LANGUAGE_API_BASE_URL,
  withCredentials: true, // send the cookies back, though Vue Dropzone may ignore that.
  // timeout: 20000, // 20 seconds because quick-translate might need it
  // validateStatus: () => true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
    // 'x-auth-token': this.authTokenCookie,
  },
  responseType: 'blob'
})

apiClientBlob.interceptors.request.use(
  (request) => {
    if (!!process.env.VUE_APP_DEBUG) {
      // console.log(`Interceptor request:  ${request.url}`)
    }
    request.config = {
      ...(request.config ?? {}) // preserve a given request.config object
    }
    NProgress.start()
    return request
  }
)

// Response interceptor take 2 arguments - a success callback and an error callback.
apiClientBlob.interceptors.response.use(
  (response) => {
    NProgress.done()
    return response
  },
  (error) => {
    NProgress.done()
    if (error.response && error.response.status === 403) {
      router.push('/logout')
      // console.log(router)
    } else if (error.response) {
      /*
        * The request was made and the server responded with a
        * status code that falls out of the range of 2xx
        */
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
    } else if (error.request) {
      /*
        * The request was made but no response was received, `error.request`
        * is an instance of XMLHttpRequest in the browser and an instance
        * of http.ClientRequest in Node.js
        */
      console.log(error.request)
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log('Error', error.message)
    }
    return Promise.reject(error)
  }
)

export default apiClientBlob
